export enum ETipoEmissao {
  EmissaoPropria = 1,
  EmissaoTerceiro = 2,
}
